import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.423 7.996l.002.004-.002.004a15.868 15.868 0 01-1.988 2.655C12.064 12.126 10.19 13.5 8 13.5c-2.19 0-4.066-1.374-5.434-2.841A15.865 15.865 0 01.577 8.004L.575 8l.002-.004a15.868 15.868 0 011.988-2.655C3.936 3.875 5.81 2.5 8 2.5c2.19 0 4.066 1.375 5.434 2.841a15.871 15.871 0 011.989 2.655z",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.167 8c0 1.24-.981 2.227-2.167 2.227S5.833 9.241 5.833 8c0-1.24.98-2.227 2.167-2.227 1.186 0 2.167.986 2.167 2.227z",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }